import { render, staticRenderFns } from "./DeliveryPointForm.vue?vue&type=template&id=8c008080"
import script from "./DeliveryPointForm.vue?vue&type=script&lang=js"
export * from "./DeliveryPointForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointForm.vue?vue&type=style&index=0&id=8c008080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports